import React from 'react';
import { Route } from 'react-router-dom';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import Fleet from './fleet';
import FleetDetail from './fleet-detail';
import FleetUpdate from './fleet-update';
import FleetDeleteDialog from './fleet-delete-dialog';

const FleetRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<Fleet />} />
    <Route path="new" element={<FleetUpdate />} />
    <Route path=":id">
      <Route index element={<FleetDetail />} />
      <Route path="edit" element={<FleetUpdate />} />
      <Route path="delete" element={<FleetDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default FleetRoutes;
